import nanoid from 'nanoid/generate';
import { alphabet, length } from '../../../blocks/constants/generator-options';

const regEx = new RegExp(`-[${alphabet}]{${length}}$`);

function updateBlockId(currentId) {
  let baseId = currentId;
  const hasUniqueId = regEx.test(currentId);
  const uniqueId = nanoid(alphabet, length);
  if (hasUniqueId) {
    baseId = currentId.replace(regEx, '');
  }

  return `${baseId}-${uniqueId}`;
}

export default updateBlockId;
